import { Phone } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";

export function FAQ() {
  const faqs = [
    {
      question: "Qual é o horário de funcionamento?",
      answer: "Estamos abertos de segunda a sábado, das 11:15h às 23:15h. Fechados aos domingos."
    },
    {
      question: "Vocês fazem entregas?",
      answer: "Sim! Fazemos entregas por meio do iFood ou você pode solicitar diretamente via WhatsApp. A taxa de entrega varia conforme a região."
    },
    {
      question: "Quais formas de pagamento vocês aceitam?",
      answer: "Aceitamos dinheiro, cartões de crédito e débito, Pix e pagamento online através do iFood."
    },
    {
      question: "Qual é o tempo médio de entrega?",
      answer: "O tempo médio de entrega varia entre 30 a 45 minutos, dependendo da sua localização e do movimento do dia."
    },
    {
      question: "Vocês têm opções vegetarianas?",
      answer: "Sim, oferecemos opções vegetarianas em nosso cardápio. Consulte as opções disponíveis com nossos atendentes."
    },
    {
      question: "É possível personalizar meu lanche?",
      answer: "Com certeza! Você pode adicionar ou remover ingredientes conforme sua preferência. Basta informar ao realizar seu pedido."
    }
  ];

  return (
    <section id="faq" className="bg-background text-foreground py-12 sm:py-16 transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-amber-600 dark:text-krecao-yellow mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-gray-700 dark:text-gray-300 max-w-2xl mx-auto text-sm sm:text-base">
            Tire suas dúvidas sobre nossos produtos e serviços
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* FAQ Accordion */}
          <div className="bg-card border border-border rounded-lg p-4 sm:p-6 shadow-sm">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`faq-${index}`} className="border-b border-border">
                  <AccordionTrigger className="text-gray-950 dark:text-white hover:text-amber-600 dark:hover:text-krecao-yellow font-semibold text-left">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-800 dark:text-gray-300 font-medium">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* Contact CTA */}
          <div className="bg-card border border-border rounded-lg p-4 sm:p-6 text-center flex flex-col items-center justify-center shadow-sm">
            <h3 className="text-xl sm:text-2xl font-bold text-amber-600 dark:text-krecao-yellow mb-4">
              Ainda tem dúvidas?
            </h3>
            <p className="text-gray-700 dark:text-gray-300 mb-6 text-sm sm:text-base">
              Entre em contato conosco por telefone ou WhatsApp para mais informações.
            </p>
            <div className="flex flex-col space-y-4 w-full max-w-sm">
              <Button 
                className="bg-krecao-red hover:bg-krecao-red/90 text-white flex items-center justify-center gap-2 text-sm sm:text-base font-semibold"
                onClick={() => window.open('tel:5132422047')}
              >
                <Phone size={18} />
                Ligar para (51) 3242-2047
              </Button>
              <Button 
                className="bg-green-600 hover:bg-green-700 text-white text-sm sm:text-base font-semibold"
                onClick={() => window.open('https://wa.me/5132422047?text=Olá! Tenho uma dúvida sobre o K-recão Lanches.', '_blank')}
              >
                WhatsApp
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
